<app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray"></app-sg-aria-message>
<h1>単価表検索</h1>
<!-- Select what to search -->
<mat-accordion class="expantion-style">
    <mat-expansion-panel class="sg-search-condition-expansion" [expanded]="true">
        <mat-expansion-panel-header>
            <mat-panel-title class="title">検索条件</mat-panel-title>
        </mat-expansion-panel-header>
        <div>
            <form [formGroup]="tankatableConditionForm">
                <app-sgkc021d-tanka-table-search-condition [sgkc026aResponse]="sgkc026aResponse"
                    [codeConversionMstMap]="codeConversionMstMap" [mode]="displayMode" (onClickClearEvent)="onClickClear()"
                    (onClickSearchEvent)="onClickSearch()"></app-sgkc021d-tanka-table-search-condition>
            </form>
        </div>
    </mat-expansion-panel>
</mat-accordion>
<div *ngIf="showResult && searchResult.length > 0">
    <mat-card class="cur-card">
        <app-sgkc021d-tanka-table-search-result [tankatable]="searchResult" [mode]="displayMode"
            (onDbClickRowEvent)="onDbClickRow($event)" (onClickAddEvent)="onClickAdd()"
            (onSelectedEvent)="onSelected($event)" id="resultComponent"></app-sgkc021d-tanka-table-search-result>
        <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center">
        </div>
    </mat-card>
</div>